{
  "nav": {
    "overview": "نظرة عامة",
    "servers": "السيرفرات",
    "billing": "الفوترة",
    "ai-credits": "نقاط الذكاء الاصطناعي",
    "team": "الفريق",
    "support": "الدعم",
    "releases": "الإصدارات",
    "settings": "الإعدادات",
    "groups": {
      "account": "الحساب"
    }
  },
  "a11y": {
    "mainNav": "التنقل الرئيسي",
    "home": "bPanel، النظرة العامة",
    "skip": "انتقل إلى المحتوى",
    "openMenu": "فتح القائمة",
    "collapseSidebar": "طي القائمة",
    "expandSidebar": "توسيع القائمة"
  },
  "help": {
    "docs": "الوثائق",
    "status": "حالة الخدمة"
  },
  "mock": {
    "badge": "بيانات تجريبية",
    "reset": "إعادة ضبط البيانات التجريبية",
    "resetTitle": "إعادة ضبط البيانات التجريبية؟",
    "resetBody": "ستعود كل الحسابات والسيرفرات والفواتير التجريبية إلى حالتها الأولى، وسنسجّل خروجك.",
    "resetConfirm": "إعادة الضبط",
    "resetDone": "عادت البيانات التجريبية إلى حالتها الأولى."
  },
  "language": {
    "other": "English",
    "switchTo": "Switch to English"
  },
  "org": {
    "switch": "تبديل الشركة",
    "title": "شركاتك"
  },
  "notifications": {
    "label": "الإشعارات",
    "labelUnread_zero": "الإشعارات",
    "labelUnread_one": "الإشعارات، إشعار واحد جديد",
    "labelUnread_two": "الإشعارات، إشعاران جديدان",
    "labelUnread_few": "الإشعارات، {{count}} إشعارات جديدة",
    "labelUnread_many": "الإشعارات، {{count}} إشعارًا جديدًا",
    "labelUnread_other": "الإشعارات، {{count}} إشعار جديد",
    "title": "الإشعارات",
    "markAll": "تعليم الكل كمقروء",
    "empty": "ليس لديك إشعارات",
    "viewAll": "عرض كل الإشعارات"
  },
  "user": {
    "menu": "قائمة الحساب",
    "profile": "الملف الشخصي",
    "settings": "الإعدادات",
    "signOut": "تسجيل الخروج"
  },
  "command": {
    "title": "بحث",
    "trigger": "ابحث أو انتقل إلى...",
    "placeholder": "اكتب اسم صفحة أو سيرفر أو إجراء",
    "empty": "لا توجد نتائج",
    "groups": {
      "pages": "الصفحات",
      "servers": "السيرفرات",
      "actions": "إجراءات"
    },
    "actions": {
      "addServer": "إضافة سيرفر",
      "activate": "تفعيل سيرفر برمز"
    }
  },
  "banners": {
    "dunning": {
      "title": "لم تنجح دفعة التجديد.",
      "amount": "المبلغ المستحق",
      "failedOn": "منذ {{date}}.",
      "body": "سيرفراتك تعمل كالمعتاد خلال مهلة الدفع، وبعدها تُقفل لوحة التحكم حتى تدفع.",
      "action": "ادفع الآن"
    },
    "trial": {
      "title_zero": "تجربتك المجانية تنتهي اليوم.",
      "title_one": "يتبقى يوم واحد على نهاية تجربتك المجانية.",
      "title_two": "يتبقى يومان على نهاية تجربتك المجانية.",
      "title_few": "يتبقى {{count}} أيام على نهاية تجربتك المجانية.",
      "title_many": "يتبقى {{count}} يومًا على نهاية تجربتك المجانية.",
      "title_other": "يتبقى {{count}} يوم على نهاية تجربتك المجانية.",
      "noCard": "جهّز الدفع حتى تستمر سيرفراتك دون انقطاع.",
      "withCard": "الدفع جاهز، والاشتراك يبدأ تلقائيًا في {{date}}.",
      "action": "جهّز الدفع"
    },
    "grace": {
      "title": "{{server}} غير متصل بـ bPanel.",
      "until": "المواقع تعمل كالمعتاد. إذا لم يتصل السيرفر قبل {{date}}، تتوقف إضافة حسابات جديدة.",
      "body": "المواقع تعمل كالمعتاد، لكن إضافة حسابات جديدة تتوقف إذا طال الانقطاع.",
      "action": "عرض السيرفر"
    },
    "locked": {
      "title": "لوحة تحكم {{server}} مقفلة.",
      "body": "انتهى الاشتراك. المواقع والبريد تعمل، ولا نحذف أي شيء.",
      "action": "جدّد الآن"
    }
  },
  "focus": {
    "exit": "العودة إلى اللوحة"
  }
}
